import './view.scss';

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.content-toggle-wrap').forEach((wrap, groupIndex) => {
        const tabs = [...wrap.querySelectorAll('.content-nav-item')];
        const panels = [...wrap.querySelectorAll('.content-main-item')];
        if (!tabs.length || tabs.length !== panels.length) return;

        tabs.forEach((tab, index) => {
            tab.id = `coto-content-tab-${groupIndex}-${index}`;
            panels[index].id = `coto-content-panel-${groupIndex}-${index}`;
            tab.setAttribute('aria-controls', panels[index].id);
            panels[index].setAttribute('aria-labelledby', tab.id);
        });
        const select = selected => {
            tabs.forEach((tab, index) => {
                const active = index === selected;
                tab.classList.toggle('active', active);
                tab.setAttribute('aria-selected', String(active));
                tab.tabIndex = active ? 0 : -1;
                panels[index].classList.toggle('active', active);
                panels[index].hidden = !active;
                panels[index].setAttribute('aria-hidden', String(!active));
            });
        };
        select(0);
        tabs.forEach((tab, index) => {
            tab.addEventListener('click', () => select(index));
            tab.addEventListener('keydown', event => {
                let next;
                if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (index + 1) % tabs.length;
                else if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (index - 1 + tabs.length) % tabs.length;
                else if (event.key === 'Home') next = 0;
                else if (event.key === 'End') next = tabs.length - 1;
                else return; // Native buttons handle Enter/Space; Tab must leave the widget.
                event.preventDefault();
                select(next);
                tabs[next].focus();
            });
        });
    });
});
